export enum E_EDITOR_CUSTOM_EVENT {
  SAVE_DESIGN = 'save-design',
  SAVE_DESIGN_SUCCESS = 'save-design-success',
  GET_PRODUCT_ITEMS = 'get-product-items',
  GET_PRODUCT_ITEMS_SUCCESS = 'get-product-items-success',
  REMOVE_ITEMS_GROUP = 'remove-items-group',
  REMOVE_ITEMS_GROUP_SUCCESS = 'remove-items-group-success',
};